<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><a id="start">For those so loved, they feel they can take love for granted.</a></p><a id="start">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4dedication.vue?7ed03dd2